import { Component } from "@angular/core";
import { Router } from "@angular/router";

import { Observable } from "rxjs";
import { Store, select } from "@ngrx/store";
import { clientConfig, errorMessages } from "../../../shared/constant/app.constant";
import { NavButton } from "../../../shared/components/navigation/next-button.component";
import { AppFlowService } from "../../../shared/services/app-flow/app-flow.service";
import { CopyHelpers } from "../../../shared/helpers/copy.helpers";

@Component({
  selector: "app-start",
  templateUrl: "./start.component.html",
  styleUrls: ["./start.component.scss"],
})
export class StartComponent {
  policyUrl: string = clientConfig.POLICYURL;
  errorMessages = errorMessages;
  brandInfo: BrandingInfo = {
    logoSrc: clientConfig.LOGO_URL,
    policyUrl: clientConfig.POLICYURL,
  };
  errorinfo = {
    title: "",
    message: "missingCriticalInfo",
  };
  flowSteps = [];
  nextButton: NavButton = {
    buttonText: "startButton",
    routeUrl: "/d/returnitem",
    cssClass: "next-btn",
  };
  orderData$: Observable<any>;
  orderDataRequired: any;
  orderData: any;
  param = { orderNumber: "" };
  constructor(private store: Store<AppState>, private router: Router, private appFlowService: AppFlowService) {
    this.orderData$ = this.store.pipe(select("orderData"));
    this.nextButton.routeUrl = `/d/${this.appFlowService.findRouteFromSequence("welcome").next}`;
    this.appFlowService.activeStepId = 0;
    const activeFlow = this.appFlowService.getActiveAppFlow();
    this.flowSteps = activeFlow.steps;
    this.orderDataRequired = activeFlow.orderDataRequired;
    this.store.pipe(select("orderData")).subscribe((order) => {
      this.orderData = CopyHelpers.deepCopy(order);
    });
    this.param.orderNumber =
      this.orderData && this.orderData.orders && this.orderData.orders[0].orderNumber
        ? this.orderData.orders[0].orderNumber
        : "";
    if (this.orderData.errorMessage === "noReturnableItems") {
      this.errorinfo.title = "";
      this.errorinfo.message = "noReturnableItems";
    }
  }

  next(): void {
    this.router.navigate(["/d/returnitems"]);
  }
}
